import {
  base_colorContentBorder,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  padding: ${spacing(5)};
  border-radius: ${cornerRadius};
  border: 1px solid ${base_colorContentBorder};

  .summary-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(3)};
  }

  .summary-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(3)};
    min-width: 0;
  }

  .plan-icon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }

  .plan-label {
    ${font_md}
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextPrimary};
  }

  .Pill {
    flex-shrink: 0;
  }
`
